<template>
  <base-panel
    :asset="asset"
    :hide-print-button="false"
    :asset-module="assetModule"
    :tabs="tabs"
    :last-update="lastUpdate"
    :notifications="notifications"
  />
</template>

<script>
import { FinalGradientTabs } from 'sigma-mappings';
import BasePanel from '@/domain/components/installation/engineering/BasePanel';
import GeneralTab from '@/domain/components/installation/engineering/finalGradient/GeneralTab';
import ChartsTab from '@/domain/components/installation/engineering/finalGradient/ChartTab';
import ParametersTab from '@/domain/components/installation/engineering/finalGradient/ParametersTab';
import Service from '@/domain/services/installation/engineering/finalGradient/finalGradientService';
import eventBus from '@/services/globalEventBus';
import LoadingMixin from '@/services/loadingMixin';
import events from '@/domain/events/engineering';
import mappingFields from '@/domain/data/installation/engineering/finalGradient/mappingFields';

export default {
  name: 'FinalGradient',
  props: {
    asset: {
      type: Object,
      default: () => ({}),
    },
    assetModule: {
      type: Object,
      default: () => ({}),
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [LoadingMixin],
  components: {
    BasePanel,
  },
  data: () => ({
    windingAmount: null,
    lastUpdate: '',
  }),
  computed: {
    tabs() {
      return [
        {
          name: FinalGradientTabs.GENERAL,
          title: this.$t('general.general'),
          component: GeneralTab,
          windingAmount: this.windingAmount,
        },
        {
          name: FinalGradientTabs.PARAMETERS,
          title: this.$t('general.parameters'),
          component: ParametersTab,
          windingAmount: this.windingAmount,
        },
        {
          name: FinalGradientTabs.CHART,
          title: this.$t('general.chart'),
          component: ChartsTab,
          windingAmount: this.windingAmount,
        },
      ];
    },
  },
  created() {
    this.getStatus(true, true);
    this.initListener();
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    getStatus(showLoading, checkParams) {
      return Service.getStatus(this.assetModule.id)
        .then((response) => {
          this.windingAmount = response.windingAmount;
          this.lastUpdate = response.lastUpdate;
          if (checkParams) {
            this.checkInvalidParams(response.algorithmExecutionCycleTime, response.invalidParams);
          }
        })
        .then(() => {
          eventBus.emit(events.refreshDataTab, showLoading);
        })
        .catch(() => {
          this.windingAmount = 0;
        });
    },
    checkInvalidParams(algorithmExecutionCycleTime, invalidParams = []) {
      if (!invalidParams.length) return;
      const messageList = [];
      const type = 'warning';
      invalidParams.forEach((param) => {
        messageList.push({
          code: 'MA092',
          messageParams: {
            0: this.$t(mappingFields[param]),
            1: algorithmExecutionCycleTime,
          },
        });
      });

      this.$pushAlert({
        messageList,
        type,
      });
    },
    initListener() {
      eventBus.on(events.refreshData, this.refreshDataEvent, this);
    },
    removeListener() {
      eventBus.off(events.refreshData, this.refreshDataEvent, this);
    },
    refreshDataEvent({ wait }) {
      wait(this.getStatus(false, false));
    },
  },
};
</script>

<style lang="sass" scoped>
  @media print
    ::v-deep .tabs > .tab-content > .tab-pane
      border-bottom: none
</style>
